import { render, staticRenderFns } from "./deactiveFood.vue?vue&type=template&id=38317839&scoped=true&"
import script from "./deactiveFood.vue?vue&type=script&lang=js&"
export * from "./deactiveFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38317839",
  null
  
)

export default component.exports